export default __webpack_public_path__ + "static/media/md-card-bg-react.e90846ea.png";